import { onImageGalleryItemUpdatePreviewUrl } from '../actions/internalActions';
import { lazyGetAttachment, lazyRefreshPreviewImageUrl } from 'owa-attachment-model-store';
import { ClientAttachmentId } from 'owa-client-ids';
import { ImageGalleryItem } from 'owa-sxsdata';

export default async function onBeforeImageGalleryItemSelected(imageGalleryItem: ImageGalleryItem) {
    const currentAttachmentId: ClientAttachmentId = imageGalleryItem.id;
    const getAttachment = await lazyGetAttachment.import();
    const attachmentModel = getAttachment(currentAttachmentId);

    // refreshPreviewImageUrl depends on attachmentModel to be available
    if (attachmentModel) {
        const refreshPreviewImageUrl = await lazyRefreshPreviewImageUrl.import();
        await refreshPreviewImageUrl(currentAttachmentId, true);

        // sometimes the effect of refreshPreviewImageUrl() is on another instance of attachment model
        // calling getAttachment again makes sure it gets the correct instance of attachment model.
        onImageGalleryItemUpdatePreviewUrl(
            imageGalleryItem,
            getAttachment(currentAttachmentId).previewImage.url
        );
    }
}
